import styled from 'styled-components';
import { dotPulse } from 'utils/style/animations';

interface IDotsProps {
  delay: number;
}

export const Dot = styled('div')<IDotsProps>`
  width: 14px;
  height: 14px;
  display: inline-block;
  animation: ${dotPulse} 0.6s ease both infinite;
  background: #298bf2;
  border-radius: 100%;
  animation-delay: ${(props) => `${props.delay}s`};
`;

export const Dots = styled('div')`
  align-self: center;
  text-align: center;
`;
